/**
 * UI code for form-item-document fields.
 *
 * Searches for elements with [data-document-field="{{id}}"].
 *
 * The 'data-document-field' should specifies the target <input> field that is sent to the server.
 *
 * After a field has been initialised it will have the following methods attached:
 *    getDocumentState(),
 *    setDocumentState(state).
 */

import 'croppie';
import util from './util';

let fileInputField; // The global / shared hidden file field.
let uploadImgCrop;
let isCropEnabled;

function init(addedNodes) {
    fileInputField = document.querySelector('#js-document-field');
    isCropEnabled = $('.upload-img').length !== 0;

    if (!fileInputField) {
        fileInputField = document.createElement('input');
        fileInputField.setAttribute('id', 'js-document-field');
        fileInputField.setAttribute('type', 'file');
        util.showElement(fileInputField, false);
        fileInputField.setAttribute('title', 'File upload field');

        if (isCropEnabled) {
            uploadImgCrop = getUploadImgCrop();
            let filename = '';
            fileInputField.addEventListener('change', function () {
                const elements = this.value.split('\\');
                filename = elements[elements.length - 1];

                if (this.files && this.files[0]) {
                    const dividedFilename = filename.split('.');
                    const fileExtension = dividedFilename.pop().toUpperCase();
                    const acceptedExtensions = ['PNG', 'JPEG', 'JPG'];
                    const validUpload = acceptedExtensions.includes(fileExtension);

                    if (validUpload) {
                        readFile(this, filename);
                        const baseId = fileInputField['data-document-field'];
                        const els = getElements(baseId);
                        els.valueField.value = true;
                        els.valueField.dispatchEvent(new CustomEvent('change', {
                            bubbles: true,
                            detail: els.valueField,
                        }));
                    } else {
                        notification.notify('Error', 'Invalid file selected, only PNG and JPEG files are permitted', -1);
                    }
                }
            });
            $('#rotateLeft').click(function () {
                uploadImgCrop.croppie('rotate', Number($(this).data('rotate')));
            });
            $('#rotateRight').click(function () {
                uploadImgCrop.croppie('rotate', Number($(this).data('rotate')));
            });
            $('.upload-msg').click(() => $('[data-document-upload]').click());

            fileInputField.addEventListener('crop.start', () => {
                handleClickCropping(uploadImgCrop, filename, true);
            });
        } else {
            fileInputField.addEventListener('change', () => {
                handleFileSelected();
            });
        }

        document.body.appendChild(fileInputField);
    }

    addedNodes.forEach((addedNode) => {
        // Initialise the list of hidden <input type=text> value fields
        forEach(addedNode.querySelectorAll('[data-document-field]'), (field) => {
            const documentId = field.getAttribute('data-document-field');
            initialiseDocumentField(documentId);
        });
    });
}

function getUploadImgCrop() {
    return $('#upload-img').croppie({
        enableExif: true,
        viewport: {
            width: 150,
            height: 150,
        },
        boundary: {
            width: 200,
            height: 200,
        },
        showZoomer: true,
        enableOrientation: true,
    });
}

function initialiseDocumentField(baseId) {
    const els = getElements(baseId);
    setLabelToFloat(els, baseId);

    if (els.valueField.getDocumentState) { // Field already initialised
        return;
    }

    els.valueField.getDocumentState = () => getDocumentState(baseId);

    els.valueField.setDocumentState = (state) => setDocumentState(baseId, state);

    forEach(els.uploadButtons, (button) => {
        button.addEventListener('click', (evt) => handleUploadButtonClick(evt, button));
    });

    forEach(els.clearButtons, (button) => {
        button.addEventListener('click', (evt) => handleClearButtonClick(evt, button));
    });
}

function handleClearButtonClick(evt, button) {
    evt.preventDefault();
    button = button || evt.target;

    const baseId = button.getAttribute('data-document-clear');
    const els = getElements(baseId);

    setDocumentState(baseId, {
        value: '',
        link: '',
        filename: '',
        status: '',
    });

    els.valueField.dispatchEvent(new CustomEvent('change', {
        bubbles: true,
        detail: els.valueField,
    }));

    if (isCropEnabled) {
        // reset croppie
        $('.upload-img').removeClass('ready');
        $('#upload-img').val('');
        uploadImgCrop.croppie('bind', {
            url: '',
        });
    }

    // var changeEvent = document.createEvent('Event');
    // changeEvent.initEvent('change', true, true);
    // fileField.dispatchEvent(changeEvent);
}

function handleUploadButtonClick(evt, button) {
    button = button || evt.target;
    evt.preventDefault();

    const baseId = button.getAttribute('data-document-upload');
    if (!baseId) {
        console.warn('Upload button pressed but missing [data-document-upload] attribute');
        return;
    }
    showFileSelector(baseId);
}

function showFileSelector(baseId) {
    fileInputField.value = ''; // If user uploads same file, callback isn't executed
    fileInputField['data-document-field'] = baseId;
    fileInputField.click();
}

function handleFileSelected() {
    if (fileInputField.files.length < 1) {
        return;
    }

    const baseId = fileInputField['data-document-field'];
    const els = getElements(baseId);
    const oldState = getDocumentState(els);

    setDocumentState(baseId, {
        status: 'Uploading file...',
    });

    util.upload(fileInputField, (err, key) => {
        if (err) {
            setDocumentState(baseId, oldState);
        } else {
            setDocumentState(baseId, { value: key });

            els.valueField.dispatchEvent(new CustomEvent('change', {
                bubbles: true,
                detail: els.valueField,
            }));
        }
    });
}

function getElements(baseId) {
    return {
        valueField:     document.getElementById(baseId), // [id=baseId] : referenced by [data-document-field=baseId] =>
        fileField:      fileInputField,
        uploadButtons:  document.querySelectorAll(`[data-document-upload='${baseId}']`),
        clearButtons:   document.querySelectorAll(`[data-document-clear='${baseId}']`),
        filenameEls:    document.querySelectorAll(`[data-document-filename='${baseId}']`),
        linkEls:        document.querySelectorAll(`[data-document-link='${baseId}']`),
        statusEls:      document.querySelectorAll(`[data-document-status='${baseId}']`),
    };
    // valueField:    The input field submitted to the server containing document ID
    // fileField:     The hidden file input field to use for uploading to the server
    // uploadButtons: The button that triggers the hidden field field
    // clearButtons:  The button that empties the input field
    // filenameEls:   The text element containing the filename
    // linkEls:       The <a href element> used to view the document
    // statusEls:     Alternative to the filename field
}

function getDocumentState(elsOrBaseId) {
    const els = typeof (elsOrBaseId) === 'string'
        ? getElements(elsOrBaseId)
        : elsOrBaseId;

    return {
        value: els.valueField.value,
        link: els.linkEls[0] && els.linkEls[0].getAttribute('href'),
        label: els.filenameEls[0] && els.filenameEls[0].textContent,
        status: els.statusEls[0] && els.statusEls[0].textContent,
    };
}

function setDocumentState(elsOrBaseId, state) {
    const els = typeof (elsOrBaseId) === 'string'
        ? getElements(elsOrBaseId)
        : elsOrBaseId;

    state = simplifyStateObject(state);

    const isEditable = !els.valueField.hasAttribute('disabled')
            && !els.valueField.hasAttribute('readonly');

    forEach(els.uploadButtons, (btn) => {
        util.showElement(btn, isEditable);
    });

    setLabelToFloat(state, elsOrBaseId);

    if (Object.prototype.hasOwnProperty.call(state, 'value')) {
        els.valueField.value = state.value;

        forEach(els.clearButtons, (btn) => {
            util.showElement(btn, (isEditable && state.value));
        });

        const formField = findFormField(els.valueField);
        if (formField) {
            const mand = els.valueField.hasAttribute('required') && !state.value;
            const ro = els.valueField.hasAttribute('readonly');
            formField.classList[mand ? 'add' : 'remove']('form-control-danger');
            formField.classList[ro ? 'add' : 'remove']('readonly');
        }
    }

    if (Object.prototype.hasOwnProperty.call(state, 'link')) {
        forEach(els.linkEls, (linkEl) => {
            linkEl.setAttribute('href', state.link);
            util.showElement(linkEl, state.link);
        });
    }

    if (Object.prototype.hasOwnProperty.call(state, 'filename')) {
        forEach(els.filenameEls, (filenameEl) => {
            filenameEl.textContent = state.filename;
            util.showElement(filenameEl, state.filename);
        });
    }

    if (Object.prototype.hasOwnProperty.call(state, 'status')) {
        forEach(els.statusEls, (statusEl) => {
            statusEl.textContent = state.status;
            util.showElement(statusEl, state.status);
        });
    }
}

function simplifyStateObject(state) {
    state = JSON.parse(JSON.stringify(state));

    if (state.value) { // the server has provided a new document key
        if (!state.link) {
            const basePath = 'file/temp/';
            state.link = basePath + encodeURIComponent(state.value);
        }

        if (!state.filename) {
            state.filename = state.value.split('~|~')[5];
        }
    }

    if (state.status) { // Caller just wants to show an "Uploading ... " message
        state.link = null;
    } else {
        state.status = null; // ensure status text is hidden
    }

    return state;
}

function forEach(arr, pred) {
    return Array.prototype.forEach.call(arr, (item) => pred(item));
}

function readFile(input, filename) {
    const reader = new FileReader();
    reader.onload = function (e) {
        $('.upload-img').addClass('ready');
        uploadImgCrop.croppie('bind', {
            url: e.target.result,
            orientation: 1,
        }).then(() => {
            uploadImgCrop.croppie('setZoom', 0);
            handleClickCropping(uploadImgCrop, filename, false);
        });
    };
    reader.readAsDataURL(input.files[0]);
}

function handleClickCropping(uploadCrop, filename, saveImage) {
    const format = filename.split('.').pop().toUpperCase() === 'PNG'
        ? 'png'
        : 'jpeg';

    uploadCrop.croppie('result', {
        type: 'blob',
        size: 'viewport',
        format,
    })
        .then((resp) => {
            const baseId = fileInputField['data-document-field'];
            const els = getElements(baseId);
            const oldState = getDocumentState(els);

            setDocumentState(baseId, {
                status: 'Uploading file...',
            });

            const dataImage = {
                type: 'base64',
                data: resp,
                filename: filename || 'image.png',
            };

            util.upload(dataImage, (err, key) => {
                if (err) {
                    setDocumentState(baseId, oldState);
                } else {
                    setDocumentState(baseId, { value: key });

                    els.valueField.dispatchEvent(new CustomEvent('change', {
                        bubbles: true,
                        detail: els.valueField,
                    }));

                    if (saveImage) {
                        const cropEndEvent = new Event('crop.end');
                        fileInputField.dispatchEvent(cropEndEvent);
                    }
                }
            });
        });
}

/**
 * Find the div.form-control needing class='disabled required etc' to be synched
 */
function findFormField(valueField) {
    const parent = util.parent(valueField, '.mb-3');

    if (parent) {
        return parent.querySelector('.form-control');
    }
}

/**
 * On survey attachments we have floating fields.
 * @param {String} state what the field is currently showing.
 * @param {String} id the id of the file attachment field.
 */
function setLabelToFloat(stateOrEls, id) {
    if (!document.querySelector(`label[for=${id}]`)) return;

    const showFloat = stateOrEls?.valueField?.value
        || stateOrEls.value
        || stateOrEls.link
        || stateOrEls.filename
        || stateOrEls.status;

    if (showFloat && document.querySelector(`label[for=${id}]`)) {
        document.querySelector(`label[for=${id}]`).classList.remove('label-normal');
    } else {
        document.querySelector(`label[for=${id}]`).classList.add('label-normal');
    }
}

util.initialiseAddedNodes(init);
